import { makeStyles } from "@material-ui/styles";


const useStyle = makeStyles({
  subTimeParent: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: "2rem",
    width: "60%",
    marginRight: "auto",
    marginLeft: "auto",
    "@media (max-width: 700px)": {
      width: "100%",
    },
  },
  scenarioInput: {
    width: 300,
    "@media (max-width: 700px)": {
      width: "100%",
      marginTop: 10,
    },
  },
  calendarInput: {
    paddingRight: "1rem",
    border: "1px solid #ccc",
    borderRadius: "0.375rem",
    color: "#495057",
    outline: "none",
    height: "44.3px",
    fontFamily: "IRANSansX",
    width: 300,
    marginLeft: 10,
    "@media (max-width: 700px)": {
      width: "100%",
      marginLeft: 0,
    },
  },
  wrapperClassName: {
    width: 300,
    marginLeft: 10,
    "@media (max-width: 700px)": {
      width: "100%",
      marginLeft: 0,
    },
  },
});

export default useStyle;
